/**
 * Лимит «из планов» для экрана Категорий.
 *
 * N = plan_month / 30, округлить.
 * НЕ путать с computeDailyBudget (utils/daily-budget.ts):
 *   тот — лимит дашборда (override из настроек + дней в текущем месяце).
 *   Этот — простой расчёт плана на день для отображения в экране Категорий.
 */

import { Category } from '../api/types';

/** Сумма plan_month повседневных расходных (type='Расход', is_daily truthy). */
export function planDailySum(cats: Category[]): number {
  return cats
    .filter((c) => c.type === 'Расход' && c.is_daily)
    .reduce((s, c) => s + (c.plan_month || 0), 0);
}

/** Дневной лимит из планов: round(planDailySum / 30). */
export function planDailyLimit(cats: Category[]): number {
  return Math.round(planDailySum(cats) / 30);
}

/** «≈+N ₽/день» для одной категории: round(plan / 30). */
export function planPerDay(plan: number): number {
  return Math.round(plan / 30);
}

/** Сумма конвертов: plan_month расходных НЕ-повседневных (is_daily = 0). */
export function planEnvelopeSum(cats: Category[]): number {
  return cats
    .filter((c) => c.type === 'Расход' && !c.is_daily)
    .reduce((s, c) => s + (c.plan_month || 0), 0);
}
